import { fmtCVE0 } from "@/lib/format";
import { periodLabel } from "@/lib/pricing";
import { Button } from "@/components/ui/button";
import { Bank, Copy, DeviceMobile } from "@phosphor-icons/react";
import { toast } from "sonner";

export const priceLabel = (v) => (v === null || v === undefined ? "[a definir]" : fmtCVE0(v));

function Row({ label, value, testid }) {
  if (!value) return null;
  return (
    <div className="flex items-start justify-between gap-3 border-b border-border/60 py-2 text-sm last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right font-medium" data-testid={testid}>{value}</span>
    </div>
  );
}

export function PaymentInstructions({ request, instructions, discountPct }) {
  const i = instructions || {};
  const empty = !i.bank && !i.iban && !i.nib && !i.vinti4 && !i.free_text;
  const copy = () => { navigator.clipboard.writeText(request.reference); toast.success("Referência copiada"); };
  return (
    <div className="space-y-4 rounded-2xl border-2 border-primary/40 bg-card p-5" data-testid="payment-instructions">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Referência única</div>
          <div className="font-mono text-2xl font-extrabold tracking-wider text-primary" data-testid="payment-reference">{request.reference}</div>
        </div>
        <Button variant="outline" size="sm" className="rounded-full" onClick={copy} data-testid="copy-reference-btn"><Copy size={15} className="mr-1.5" /> Copiar</Button>
      </div>
      <div className="rounded-lg bg-secondary px-4 py-3 text-sm">
        Plano <b>{request.plan_name}</b> · {periodLabel(request.months)} · <b data-testid="payment-amount">{priceLabel(request.amount)}</b>
        {request.founder && discountPct > 0 && <div className="mt-1 text-xs text-muted-foreground" data-testid="payment-discount-line">Preço Fundador · −{discountPct}% incluído no valor</div>}
        <div className="mt-1 text-xs text-muted-foreground">Indique a referência no descritivo do pagamento. O plano é ativado após confirmação.</div>
      </div>
      {empty ? (
        <p className="text-sm text-muted-foreground" data-testid="instructions-empty">As instruções de pagamento ainda não foram configuradas. Contacte o suporte GESTA CV.</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {(i.bank || i.iban || i.nib || i.holder) && (
            <div className="rounded-xl border border-border p-4">
              <div className="mb-2 flex items-center gap-2 font-semibold"><Bank size={18} className="text-primary" /> Transferência bancária</div>
              <Row label="Banco" value={i.bank} testid="instr-bank" />
              <Row label="Titular" value={i.holder} testid="instr-holder" />
              <Row label="NIB" value={i.nib} testid="instr-nib" />
              <Row label="IBAN" value={i.iban} testid="instr-iban" />
            </div>
          )}
          {i.vinti4 && (
            <div className="rounded-xl border border-border p-4">
              <div className="mb-2 flex items-center gap-2 font-semibold"><DeviceMobile size={18} className="text-primary" /> Vinti4</div>
              <p className="whitespace-pre-line text-sm" data-testid="instr-vinti4">{i.vinti4}</p>
            </div>
          )}
          {i.free_text && <p className="whitespace-pre-line text-sm text-muted-foreground md:col-span-2" data-testid="instr-free">{i.free_text}</p>}
        </div>
      )}
    </div>
  );
}
